module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', [_vm._v("加入代理")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('cell', [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("请选择省份")])])]), _vm._v(" "), _vm._l((_vm.provence), function(i) {
    return _c('cell', {
      key: i.id,
      attrs: {
        "is-link": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.clickProvence(i)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(i.name))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('cell', {
    attrs: {
      "is-link": "",
      "link": ("/uc/joinusdetail/" + (_vm.currentProvence.id) + "/" + (_vm.currentProvence.name))
    }
  }, [_c('div', {
    staticClass: "p",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.currentProvence.name))]), _vm._v(" "), _c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-arrow-down",
    attrs: {
      "slot": "icon",
      "type": "ios-arrow-down",
      "size": "15",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "15",
      "height": "15",
      "viewBox": "0 0 512 512"
    },
    slot: "icon"
  }, [_c('path', {
    attrs: {
      "d": "M396.6 160l19.4 20.7L256 352 96 180.7l19.3-20.7L256 310.5z"
    }
  })])]), _vm._v(" "), _vm._l((_vm.city), function(c) {
    return _c('div', [_c('cell', {
      attrs: {
        "is-link": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.clickCity(c)
        }
      }
    }, [_c('div', {
      staticClass: "c",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(c.name))]), _vm._v(" "), _c('svg', {
      staticClass: "vux-x-icon vux-x-icon-ios-arrow-right",
      attrs: {
        "slot": "icon",
        "type": "ios-arrow-right",
        "size": "12",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "12",
        "height": "12",
        "viewBox": "0 0 512 512"
      },
      slot: "icon"
    }, [_c('path', {
      attrs: {
        "d": "M160 115.4L180.7 96 352 256 180.7 416 160 396.7 310.5 256z"
      }
    })])]), _vm._v(" "), _c('group', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showIndex === c.id),
        expression: "showIndex === c.id"
      }]
    }, [_c('cell', {
      attrs: {
        "is-link": "",
        "link": ("/uc/joinusdetail/" + (c.id) + "/" + (c.name))
      }
    }, [_c('div', {
      staticClass: "r",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(c.name))]), _vm._v(" "), _c('svg', {
      staticClass: "vux-x-icon vux-x-icon-ios-minus-empty",
      attrs: {
        "slot": "icon",
        "type": "ios-minus-empty",
        "size": "12",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "12",
        "height": "12",
        "viewBox": "0 0 512 512"
      },
      slot: "icon"
    }, [_c('path', {
      attrs: {
        "d": "M384 265H128v-17h256v17z"
      }
    })])]), _vm._v(" "), _vm._l((c.r), function(r) {
      return _c('cell', {
        key: r.id,
        attrs: {
          "link": ("/uc/joinusdetail/" + (r.id) + "/" + (r.name))
        }
      }, [_c('div', {
        staticClass: "r",
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_vm._v(_vm._s(r.name))]), _vm._v(" "), _c('svg', {
        staticClass: "vux-x-icon vux-x-icon-ios-minus-empty",
        attrs: {
          "slot": "icon",
          "type": "ios-minus-empty",
          "size": "12",
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "12",
          "height": "12",
          "viewBox": "0 0 512 512"
        },
        slot: "icon"
      }, [_c('path', {
        attrs: {
          "d": "M384 265H128v-17h256v17z"
        }
      })])])
    })], 2)], 1)
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02c16020"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/Join.vue
// module id = 637
// module chunks = 0